import bk from "../../assets/imgs/class/bk.gif";
import sm from "../../assets/imgs/class/sm.gif";
import dl from "../../assets/imgs/class/dl.gif";
import mg from "../../assets/imgs/class/mg.gif";
import elf from "../../assets/imgs/class/elf.gif";
import summoner from "../../assets/imgs/class/summoner.gif";
import ragefighter from "../../assets/imgs/class/ragefighter.gif";

export const checkClass = (playerClass) => {
  switch (playerClass) {
    case 16:
    case 17:
    case 18:
      return bk;
    case 0:
    case 1:
    case 2:
      return sm;
    case 64:
    case 66:
      return dl;
    case 48:
    case 50:
      return mg;
    case 32:
    case 33:
    case 34:
      return elf;
    case 80:
    case 81:
    case 82:
      return summoner;
    case 96:
    case 97:
    case 98:
      return ragefighter;
    default:
      return "gray";
  }
};
